module.exports = __webpack_public_path__ + "assets/img/id-removebg.a8bbd14c.png";